import { graphql, Link, useStaticQuery } from "gatsby";
import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import PopularSearch from "../PopularSearch/PopularSearch";
import PopularSearchArea from "../PopularSearch/PopularSearchArea";
import PopularSearchResults from "../PopularSearch/PopularSearchResults";
import PopularSearchDetails from "../PopularSearch/PopularSearchDetails";
import "./Footer.scss";
import GetLink from "../functions/GetLink";
import parse from "html-react-parser";
import CookieConsent from "../CookieConsent/CookieConsent";
import $ from "jquery";
import { Helmet } from "react-helmet";
import { AreaGuideDetail } from "../../queries/common_use_query";
import AppointmentBanner from "../AppointmentBanner/AppointmentBanner";
import ThePropertyOmbudsmanLogo from "../../images/property_ombudsman.png";
import ApprovedCodeLogo from "../../images/approved_code.png";
import useLocation from "../../hooks/useLocation";
import { useScript } from "../../hooks/useScript";
import YomdelChatScript from "./YomdelChatScript"
import GlobalFormModal from "../PopUpForm/PopUpForm"
//const { YomdelChatScript } = require("@starberry/react-chat-widgets/Yomdel/Chat")

const Footer = (props) => {
  const data = useStaticQuery(graphql`
    query GetOfficesFooter {
      glstrapi {
        offices {
          id
          Name
          Office_Address
          Office_Address_New
          Phone
          Email
          URL
          office_crm_id
        }

        globalConfig {
          Footer {
            Footer_Menus {
              Menu_External_Link
              Menu_Label
              id
              Menu_Link {
                Primary_URL
                Secondary_URL
                Label
                id
              }
            }
            Footer_Logos {
              Logo_Label
              Logo_Link
              Logo {
                url
              }
              id
            }
            Company_Registration_Number
            Company_Registered_Address
            Disclaimer_Section
            Insta_Link
            LinkedIn_Link
            Twitter_Link
            FB_Link
            Youtube_Link
            id
          }
        }
      }
    }
  `);
  const officenumber = { 1: "10474483", 2: "13761424", 3: "04684693" };
  let { pathname, href } = useLocation();
  const offices = data?.glstrapi?.offices;
  const footer_links = data?.glstrapi?.globalConfig?.Footer?.Footer_Menus;
  const footer_data = data?.glstrapi?.globalConfig?.Footer;

  // const formattedOfficeAddress = offices?.map((office) =>
  //   office.Office_Address?.replaceAll(", ", "<br />")
  // );
  const { loading: loading, error: error, data: areaGuidedata } = AreaGuideDetail(props.postcode);

  const shareurl = typeof window !== "undefined" ? window.location.href : "";
  let year = new Date().getFullYear();

  const trackerGTM = (event) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "Phone number click",
      formType: event + " - " + shareurl,
      formId: "Phone number click",
      formName: "Phone number click",
      formLabel: "Phone number click",
    });
  };

  const showBugherd = process.env.GATSBY_SHOW_BUGHERD;

  const [renderComponent, setRenderComponent] = useState(false);
  const [showGlobalForm, setShowGlobalForm] = useState(false);

  // let scriptsrc = `https://clients.yomdel.com/tools/chat_script.js?url=${
  //   typeof document !== "undefined" && document.location.href
  // }`;

  // const status = useScript(scriptsrc, {
  //   removeOnUnmount: true,
  //   shouldPreventLoad: !renderComponent || pathname === "/property-valuation/",
  // });

  // useEffect(() => {
  //   const element1 = document.getElementById("chat-widget-container");
  //   const element2 = document.getElementById("livechat-eye-catcher");
  //   if (element1) {
  //     element1.style.display = pathname === "/property-valuation/" ? "none" : "block";
  //   }
  //   if (element2) {
  //     element2.style.display = pathname === "/property-valuation/" ? "none" : "block";
  //   }
  // }, [pathname, status, href]);


  useEffect(() => {
    const handleRender = () => {
      setRenderComponent(true);
    };
    if (!renderComponent) {
      window.addEventListener("mousemove", handleRender);
      window.addEventListener("touchmove", handleRender);
      window.addEventListener("keypress", handleRender);
    }
    return () => {
      window.removeEventListener("mousemove", handleRender);
      window.removeEventListener("touchmove", handleRender);
      window.removeEventListener("keypress", handleRender);
    };
  }, [renderComponent]);

  // Expose global popup opener for other components to use
  useEffect(() => {
    if (typeof window !== "undefined") {
      window.openGlobalPopup = (value = true) => setShowGlobalForm(!!value);
    }
    return () => {
      if (typeof window !== "undefined" && window.openGlobalPopup) {
        try { delete window.openGlobalPopup; } catch (e) { window.openGlobalPopup = undefined; }
      }
    };
  }, []);
  //console.log("footer props", officenumber[2]);

  const GetExternalLink = (props) => {
    const { link, label, className } = props;
    if (label === "Update Cookies Preferences") return null;
    return (<a className={className} href={link} target="_blank">{label}</a>);
  };

  return (
    <>
      {!props.searchResults && (
        <Container>
          <AppointmentBanner />
        </Container>
      )}
      <div className="footer-wrapper">
        <GlobalFormModal showGlobalForm={showGlobalForm} closeGlobalForm={() => setShowGlobalForm(false)} />
        {showBugherd == "true" ? (
          <Helmet>
            <script
              type="text/javascript"
              src="https://www.bugherd.com/sidebarv2.js?apikey=ky9zw4odscbpqlnsaxgbiw"
              async="true"
            ></script>
          </Helmet>
        ) : (
          ""
        )}
        <Container className="footer-container">

          {offices.map((office, i) => {
            return (
              <>
                {(office) && //.URL != "property-management"
                  <div className="footer-section">
                    <Link
                      to={`/contact-us/`}
                      state={{
                        officeid: office.id,
                        officeemail: office.Email,
                        officename: office.Name,
                      }}
                      className="office-name hover-border-black"
                    >
                      {office?.URL === "crouch-end-office-and-property-management-office" ? "Crouch End Office" :
                        office?.URL === "property-management" ? "Property Management Office" :
                        office.Name
                      }
                    </Link>
                    <p className="office-address">
                      {parse(office.Office_Address_New)}
                    </p>
                    <div className="office-contact">
                      <a
                        href={`tel:${office.Phone}`}
                        className="phone hover-border-black"
                        onClick={() => trackerGTM(office.Phone)}
                      >
                        {office.Phone}
                      </a>
                      <Link
                        to={`/contact-us/`}
                        state={{
                          officeid: office.id,
                          officeemail: office.Email,
                          officename: office.Name,
                        }}
                        className="email hover-border-black mt-1"
                      >
                        Email Office
                      </Link><br />
                    </div>
                    {office?.URL === "property-management" && // Property Management office}
                      <div className="footer-section footer-links-section">
                        <div className="icons">
                          <a href={footer_data.Twitter_Link} target="_blank" className="icon-twitter-new"></a>
                          <a href={footer_data.FB_Link} target="_blank" className="icon-fb-new"></a>
                          <a href={footer_data.Insta_Link} target="_blank" className="icon-insta-new"></a>
                          <a href={footer_data.LinkedIn_Link} target="_blank" className="icon-linkedin-new"></a>
                          <a href={footer_data.Youtube_Link} target="_blank" className="icon-youtube-new"></a>
                          {/* <a href="javascript:;" target="_blank" className="icon-tiktok"></a> */}
                        </div>
                        <div className="footer-links">
                          <p className="links">
                            {footer_links.map((linkItem, i) => {
                              const isCookieLink = linkItem?.Menu_Label === "Update Cookies Preferences";
                              return (
                                <>
                                  {isCookieLink ? (
                                    <a href="javascript:void(0);" id="open_preferences_center" class="hover-border-black">Update Cookies Preferences</a>
                                  ) : linkItem?.Menu_External_Link ? (
                                    <GetExternalLink
                                      link={linkItem.Menu_External_Link}
                                      label={linkItem.Menu_Label}
                                      className="hover-border-black"
                                    />
                                  ) : (
                                    <GetLink
                                      link={linkItem.Menu_Link}
                                      label={linkItem.Menu_Label}
                                      className="hover-border-black"
                                    />
                                  )}
                                  {i < footer_links.length - 1 ? "  |  " : ""}
                                </>
                              );
                            })}
                          </p>
                          <p className="copyright">Copyright {year} David Astburys Estate Agents.</p>
                        </div>
                      </div>
                    }
                  </div>
                }
              </>
            );
          })}
        </Container>
        <Container>
          <div className="logo-section">
            <p className="office-address">
              <span>*Company registration address 27 Mortimer Street, London W1T 3BL</span>
            </p>
          </div>
          <p>&nbsp;</p>
          <div className="logo-section">
            {footer_data.Footer_Logos.map((logoItem, i) => {
              return (
                <a
                  href={logoItem.Logo_Link}
                  target="_blank"
                  aria-label={logoItem.Logo_Label}
                >
                  <img src={logoItem.Logo.url} alt={logoItem.Logo_Label} loading="lazy" />
                </a>
              );
            })}
          </div>
          {/* <p className="company-extra-info">
            <p>
              Company registration number: <strong>&nbsp;{footer_data.Company_Registration_Number}</strong>
              &nbsp;|&nbsp; Company registered address:{" "}
              <strong>&nbsp;{footer_data.Company_Registered_Address}</strong>
            </p>
          </p> */}
        </Container>
        <Container className="disclaimer-wrapper d-block d-lg-flex">
          <p className="disclaimer-section">
            {footer_data.Disclaimer_Section}
          </p>
          <p className="site-by">
            Site by <a href="https://starberry.tv/" className="icon-sb" target="_blank"></a>
          </p>
        </Container>
        <Container className="divider-container">
          <div className="horizontal-divider-footer"></div>
        </Container>
        {props.popularsearch === "pagedetails" ? (
          <PopularSearchArea area={props.area} />
        ) : props.popularsearch === "results" ? (
          <PopularSearchResults searchParams={props.searchParams} />
        ) : props.popularsearch === "propertydetails" ? (
          <PopularSearchDetails
            area={props.area}
            searchaction={props.searchaction}
            areaguides={areaGuidedata?.areaguides[0]}
          />
        ) : (
          <PopularSearch popularsearch={props.popularsearch} />
        )}

        <CookieConsent />
      </div>
      <YomdelChatScript />
    </>
  );
};

export default Footer;
